export default "__VITE_PUBLIC_ASSET__7fd13ef5__"